import { CookiesUrlClient } from 'online-customer-services-ts'
import { CookiesRepository } from '@/core/cookies/domain/CookiesRepository.ts'
import { CookiesUrl } from '@/core/cookies/domain/Cookies.ts'

export class CookiesRepositoryBackendClient implements CookiesRepository {
  private readonly cookiesClient: CookiesUrlClient

  constructor(url: string) {
    this.cookiesClient = new CookiesUrlClient(url)
  }

  async getCookiesUrl(hostId: string): Promise<CookiesUrl> {
    const { url } = await this.cookiesClient.getCookiesUrl(hostId)
    return url ?? ''
  }
}
